export const LoadingState = Object.freeze({
  UNKNOWN: 'UNKNOWN',
  LOADING: 'LOADING',
  DONE: 'DONE',
  ERROR: 'ERROR',
  NOT_FOUND: 'NOT_FOUND',
});

export type LoadingState = (typeof LoadingState)[keyof typeof LoadingState];
